import type { IFlightScheduleChangeModalData } from "@tenant/flights";
import { ContactSupportModalContent } from "@tenant/self-serve";

export interface IFlightScheduleChangeContactSupportProps {
  classNames?: Partial<{
    contentBody: string;
    root: string;
    title: string;
    subtitle: string;
  }>;
  supportId?: string;
  text: IFlightScheduleChangeModalData["text"];
}

export const FlightScheduleChangeContactSupport = (
  props: IFlightScheduleChangeContactSupportProps
) => {
  const { classNames, supportId, text } = props;

  return (
    <div className={classNames?.root}>
      <div className={classNames?.contentBody}>
        <span className={classNames?.title}>{text.contactSupport.title}</span>
        <span className={classNames?.subtitle}>
          {text.contactSupport.subtitle}
        </span>
        <ContactSupportModalContent bookingSupportId={supportId} />
      </div>
    </div>
  );
};
